import { TSearchResponseDTO } from 'src/app/project/modules/points/point-search/point-search.consts';
import { TUser } from 'src/app/project/modules/user/user.model';

const SITE_VIEW = 'site';
const OVERVIEW_VIEW = 'overview';

export type TSlowTableLoadReport = {
  url: string;
  view: typeof SITE_VIEW | typeof OVERVIEW_VIEW;
  workspaceId: string;
  userEmail: string;
  userId: string;
  accountId: string;
  keyword: string;
  grouping: string[];
  searchPayload: TSearchResponseDTO | null;
};

export const buildSlowTableLoadReport = ({
  url,
  overview,
  workspaceId,
  user,
  keyword,
  grouping,
  searchPayload,
}: {
  url: string;
  overview: boolean;
  workspaceId: string;
  user: TUser;
  keyword: string;
  grouping: string[];
  searchPayload: TSearchResponseDTO | null;
}): TSlowTableLoadReport => ({
  url,
  view: overview ? OVERVIEW_VIEW : SITE_VIEW,
  workspaceId,
  userEmail: user?.email ?? '',
  userId: user?.userId ?? '',
  accountId: user?.accountId ?? '',
  keyword,
  grouping,
  searchPayload,
});
